<template>
  <div>
    <va-notification
      v-model="error"
      color="danger"
      class="mb-4"
    >
      {{ loginError[0] }}
    </va-notification>

    <form @submit.prevent="onsubmit">
      <va-input
        v-model="email"
        type="email"
        :label="$t('auth.email')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
      />

      <va-input
        v-model="password"
        type="password"
        :label="$t('auth.password')"
        :error="!!passwordErrors.length"
        :error-messages="passwordErrors"
      />

      <div class="auth-layout__options d-flex align--center justify--space-between">
        <!-- <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/> -->
        <!-- <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link> -->
      </div>

      <div class="d-flex justify--center mt-3">
        <va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '../../../api'
import Cookies from 'js-cookie'

export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
      loginError: [],
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
    error () {
      return !!this.loginError.length
    },
  },
  created () {
    Cookies.remove('admin-logged')
  },
  methods: {
    async onsubmit () {
      this.emailErrors = this.email ? [] : ['Email é obrigatório']
      this.passwordErrors = this.password ? [] : ['Senha é obrigatório']

      if (!this.formReady) {
        return
      }

      try {
        const login = await api.post('/login', { username: this.email, password: this.password })

        //console.log({headers: login.headers, data: login.data})
        Cookies.set('admin-logged', login.headers.authorization)
        Cookies.set('user', JSON.stringify({ name: login.headers.user, role: login.headers.permission }))

        this.$router.push({ name: 'categories' })
      } catch (err) {
        console.dir(err.message)
        this.loginError = ['Verifique suas credenciais']
      }
    },
  },
}
</script>

<style lang="scss">
/* .va-input__container {
  border-radius: 0;
  background-color: #ffffff !important;
} */
</style>
